module.exports.datamodel_version             = require("./datamodel_version");

// General data classes
// =====================
module.exports.Coord                         = require("./versionedGeometry.js").Coord;
module.exports.Coord3d                       = require("./versionedGeometry.js").Coord3d;
module.exports.Line                          = require("./versionedGeometry.js").Line;
// module.exports.Segment                       = require("./versionedGeometry.js").Segment;
module.exports.BoundingBox                   = require("./versionedGeometry.js").BoundingBox;
module.exports.Polygon                       = require("./versionedGeometry.js").Polygon;
module.exports.ComplexPolygon                = require("./versionedGeometry.js").ComplexPolygon;
module.exports.MultiPolygon                  = require("./versionedGeometry.js").MultiPolygon;

module.exports.PosData                       = require("./abstract/posData.js");
module.exports.PosAngleData                  = require("./abstract/posAngleData.js");
module.exports.PosAngleFlipData              = require("./abstract/posAngleFlipData.js");
module.exports.PosAngleScaleData             = require("./abstract/posAngleScaleData.js");
module.exports.WidthHeightData               = require("./abstract/widthHeightData.js");

module.exports.RectangleData                 = require("./svg/rectangleData.js");
module.exports.TriangleData                  = require("./svg/triangleData.js");
module.exports.EllipseData                   = require("./svg/ellipseData.js");
module.exports.LineData                      = require("./svg/lineData.js");
module.exports.PathData                      = require("./svg/pathData.js");
module.exports.PathObjectData                = require("./svg/pathObjectData.js");
module.exports.PolyPointMode                 = require("./svg/polyPointMode.js");
module.exports.PathPointMode                 = require("./svg/pathPointMode.js");
module.exports.PathType                      = require("./svg/pathType.js");
module.exports.TextData                      = require("./svg/textData.js");
module.exports.textTracer                    = require("./svg/fonts/textTracer.js");
module.exports.LogoData                      = require("./svg/logoData.js");
module.exports.PropertyData                      = require("./svg/propertyData.js");

module.exports.ContentServerMetaData         = require("./contentServerMetaData.js");
module.exports.HoleData                      = require("./footprint/holeData.js");
// module.exports.AbstractPadData              = require("./abstract/abstractPadData");
// module.exports.AbstractSegmentData          = require("./abstract/abstractSegmentData");
module.exports.LogicTerminalData            = require("./abstract/logicTerminalData.js");

// Symbol data
// =====================
module.exports.SymbolData                    = require("./symbol/symbolData.js");
module.exports.SymbolMetaData                = require("./symbol/symbolMetaData.js");
module.exports.SymbolTerminalData            = require("./symbol/symbolTerminalData.js");
module.exports.SymbolGeneratorData           = require("./symbol/symbolGeneratorData.js");

// Footprint data
// =====================
module.exports.FootprintData                  = require("./footprint/footprintData.js");
module.exports.FootprintMetaData              = require("./footprint/footprintMetaData.js");
module.exports.PadData                        = require("./footprint/padData.js");
module.exports.SmdPadstackData                = require("./padstack/smdPadstackData.js");
module.exports.PthPadstackData                = require("./padstack/pthPadstackData.js");
module.exports.PadReplicatorData              = require("./footprint/padReplicatorData.js");
module.exports.QuadPadReplicatorData          = require("./footprint/quadPadReplicatorData.js");
module.exports.GenericSmdPadGeneratorData     = require("./footprint/genericSmdPadGeneratorData.js");
module.exports.GenericPthPadGeneratorData     = require("./footprint/genericPthPadGeneratorData.js");
module.exports.GenericSmdQuadPadGeneratorData = require("./footprint/genericSmdQuadPadGeneratorData.js");

module.exports.IpcDataModel                   = require("./footprint/ipcFootprintGenerator/index.js");
module.exports.IpcNameHelper                  = require("./footprint/ipcFootprintGenerator/ipcNameHelper.js");
module.exports.IpcDescriptionHelper           = require("./footprint/ipcFootprintGenerator/ipcDescriptionHelper.js");
module.exports.IpcPackageParamHelper          = require("./footprint/ipcFootprintGenerator/ipcPackageParamHelper.js");
module.exports.FootprintGeneratorAddHelper    = require("./footprint/ipcFootprintGenerator/footprintGeneratorAddHelper.js");
module.exports.MetaDataUpdateHelper           = require("./footprint/ipcFootprintGenerator/metaDataUpdateHelper.js");
module.exports.FootprintMetaData              = require("./footprint/footprintMetaData.js");
module.exports.RestrictData                   = require("./footprint/restrictData.js");
module.exports.SolderMaskData                 = require("./footprint/solderMaskData.js");
module.exports.SolderPasteData                = require("./footprint/solderPasteData.js");
module.exports.GlueData                       = require("./footprint/glueData.js");
module.exports.LayeredShapeData               = require("./footprint/layeredShapeData.js");

// Package data
// =====================
module.exports.PackageData                   = require("./package/packageData.js");
module.exports.PackageMetaData               = require("./package/packageMetaData");
module.exports.FootprintInstanceData         = require("./package/footprintInstanceData.js");
module.exports.ThreejsDefaults               = require("./package/threejsDefaults.js");
module.exports.BoxData                       = require("./model3d/boxData.js");
module.exports.Model3DReference              = require("./model3d/model3DReference");
module.exports.Model3dDummyData              = require("./model3d/model3dDummyData.js");

// Component data
// =====================
module.exports.ComponentData                 = require("./component/componentData.js");
module.exports.ComponentMetaData             = require("./component/componentMetaData.js");
module.exports.ComposedSymbolData            = require("./component/composedSymbolData.js");
module.exports.SymbolInstanceData            = require("./component/symbolInstanceData.js");
module.exports.PackageInstanceData           = require("./component/packageInstanceData.js");
module.exports.PropValueData				 = require("./component/propValueData.js");
module.exports.PropValueUnitData			 = require("./component/propValueUnitData.js");

// Circuit data
// =====================
module.exports.CircuitData                   = require("./circuit/circuitData.js");
module.exports.CircuitMetaData               = require("./circuit/circuitMetaData.js");
module.exports.ComponentInstanceData         = require("./circuit/netlist/componentInstanceData.js");
module.exports.PropertyInstanceData           = require("./circuit/netlist/propertyInstanceData.js");
module.exports.NetData                       = require("./circuit/netlist/netData.js");
module.exports.NetlistData                   = require("./circuit/netlist/netlistData");
module.exports.LogicTerminalInstance         = require("./circuit/netlist/logicTerminalInstance.js");

module.exports.SchematicData                 = require("./circuit/schematic/schematicData");
module.exports.SchematicElementData          = require("./circuit/schematic/schematicElementData.js");
module.exports.SchematicTerminal             = require("./circuit/schematic/schematicTerminal.js");
module.exports.SchematicLabelTerminal        = require("./circuit/schematic/schematicLabelTerminal.js");
module.exports.SchematicNetData              = require("./circuit/schematic/schematicNetData.js");
module.exports.SchematicSegmentData          = require("./circuit/schematic/schematicSegmentData.js");
module.exports.SchematicDotData              = require("./circuit/schematic/schematicDotData.js");

module.exports.SchematicNetLabelData            = require("./circuit/schematic/schematicNetLabelData.js").SchematicNetLabelData;
module.exports.SchematicGndLabelData            = require("./circuit/schematic/schematicNetLabelData.js").SchematicGndLabelData;
module.exports.SchematicVccLabelData            = require("./circuit/schematic/schematicNetLabelData.js").SchematicVccLabelData;

module.exports.PcbData                       = require("./circuit/pcb/pcbData");
module.exports.PcbElementData                = require("./circuit/pcb/pcbElementData.js");
module.exports.PcbTerminal                   = require("./circuit/pcb/pcbTerminal.js");
module.exports.PcbHole                       = require("./circuit/pcb/pcbHole.js");
module.exports.RoutingSegmentData            = require("./circuit/pcb/routingSegmentData.js");
module.exports.RoutingVertexData             = require("./circuit/pcb/routingVertexData.js");
module.exports.ViaData                       = require("./circuit/pcb/viaData.js");
module.exports.FabData                       = require("./circuit/pcb/fabData");
module.exports.CopperPourData                = require("./circuit/pcb/copperPourData.js");

// Library Data
// =====================
module.exports.LibraryData                   = require("./library/libraryData.js");
module.exports.LibraryMetaData               = require("./library/libraryMetaData.js");


// module.exports.LegacyMigrationData           = require("./migration/legacyMigrationData.js");
module.exports.generateDatamodelDescription  = require("./generateDatamodelDescription"); // TODO: shouldn't be included in the index!

//module.exports.HeaderData                    = require("./header/headerData");
//module.exports.DocumentData                  = require("./header/documentData"); 


module.exports.FootprintLayers = require("./footprint/footprintLayers.js");
module.exports.MaterialTypes = require("./materialTypes.js");
module.exports.ThermalConnectionTypes = require("./thermalConnectionTypes.js");

module.exports.Generate3DPackage = require("./generate3DPackage.js");
